<template>
  <p v-if="affirmation" class="text-2xl">
    {{ decode(affirmation) }}
  </p>
  <template v-if="useNativeAudio">
    <p v-if="audio" class="dev-only admin-only">
      <audio
        controls
        controlslist="nofullscreen nodownload noremoteplayback"
        preload="auto"
        :type="audio.type"
        :src="audio.src"
      />
    </p>
  </template>
  <Wysiwyg class="font-serif" :markup="body" />
</template>

<script lang="ts" setup>
import { decode } from 'html-entities'

type Html = string

const { useNativeAudio } = usePreferences()

defineProps<{
  affirmation?: string
  body?: Html
  audio?: {
    src: string
    type?: string
  }
}>()
</script>
